export const productCode = {
  car: "1",
  carLeasing: "4",
  heavyCar: "3",
  heavyCarLeasing: "5",
};

export default {
  productCode,
};
